import LayoutWrapper from "../components/LayoutWrapper";
import HeaderBar from "../components/HeaderBar";
import { useState, useContext } from "react";
import getCurrentSkin from "../utils/getCurrentSkin";
import { ThemeContext } from "../context/ThemeContext";

const FormTemplate = () => {
  // const [isDark, setIsDark] = useState(false);
  // const [skin, setSkin] = useState("emerald");
  
  const { isDark, setIsDark, skin, setSkin } = useContext(ThemeContext);
const currentSkin =getCurrentSkin(skin)
  const { baseColor, baseShade } = currentSkin;

  const inputClass = `w-full px-4 py-2 rounded-lg text-sm border focus:outline-none focus:ring-2 ${
    isDark
      ? "bg-gray-800 text-white border-white/20 focus:ring-blue-400"
      : "bg-white text-black border-gray-300 focus:ring-blue-400"
  }`;

  const labelClass = `block mb-1 font-medium ${
    isDark ? "text-gray-300" : "text-gray-700"
  }`;

  return (
    <LayoutWrapper
      isDark={isDark}
      setIsDark={setIsDark}
      skin={skin}
      setSkin={setSkin}
    >
      <HeaderBar title="Add New Order" setSkin={setSkin} currentSkin={skin} />

      <div
        className={`p-6 mt-6 rounded-2xl shadow-xl border ${
          isDark
            ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
            : `bg-white ${currentSkin.glass} text-black`
        }`}
      >
        <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Requisition No */}
          <div>
            <label className={labelClass}>Requisition No</label>
            <input type="text" className={inputClass} placeholder="Enter Requisition No" />
          </div>

          {/* Date */}
          <div>
            <label className={labelClass}>Date</label>
            <input type="date" className={inputClass} />
          </div>

          {/* Branch */}
          <div>
            <label className={labelClass}>Branch</label>
            <input type="text" className={inputClass} placeholder="Enter Branch Code" />
          </div>

          {/* Department */}
          <div>
            <label className={labelClass}>Department</label>
            <input type="text" className={inputClass} placeholder="Enter Department" />
          </div>

          {/* H.O.D */}
          <div>
            <label className={labelClass}>H.O.D</label>
            <input type="text" className={inputClass} placeholder="Enter HOD Name" />
          </div>

          {/* Indent Ref */}
          <div>
            <label className={labelClass}>Indent Reference</label>
            <input type="text" className={inputClass} placeholder="Enter Indent Ref" />
          </div>

          {/* Head Material */}
          <div>
            <label className={labelClass}>Head Material</label>
            <input type="text" className={inputClass} placeholder="Enter Material Info" />
          </div>

          {/* Vehicle Code */}
          <div>
            <label className={labelClass}>Vehicle Code</label>
            <input type="text" className={inputClass} placeholder="Enter Vehicle Code" />
          </div>

          {/* Vehicle Number */}
          <div>
            <label className={labelClass}>Vehicle Number</label>
            <input type="text" className={inputClass} placeholder="Enter Vehicle Number" />
          </div>

          {/* Cumulative */}
          <div>
            <label className={labelClass}>Cumulative</label>
            <input type="text" className={inputClass} placeholder="Enter Cumulative" />
          </div>

          {/* Remarks (Full Width) */}
          <div className="md:col-span-2">
            <label className={labelClass}>Remarks</label>
            <textarea rows="4" className={inputClass} placeholder="Any additional remarks..." />
          </div>

          {/* Submit Button */}
          <div className="md:col-span-2 text-right">
            <button
              type="submit"
              className={`px-6 py-2 text-white text-sm rounded-lg shadow ${`bg-${baseColor}-${baseShade}`} hover:bg-${baseColor}-700`}
            >
              Submit Order
            </button>
          </div>
        </form>
      </div>
    </LayoutWrapper>
  );
};

export default FormTemplate;
